import { errorDialog } from '@src/components/CustomDialog';
import PropTypes from 'prop-types';

import { Text } from '@src/components';

const UTTSErrorModal = ({ processUTTSDevice }) => {
  errorDialog({
    className: 'not-show-warning-buttons',
    okButtonProps: 'not-show-warning-buttons',
    title: (
      <div className="utts-modal-1-head">
        <span className="utts-modal-1-head-text">
          <Text t="error" />
        </span>
      </div>
    ),
    htmlContent: (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <b
          className="vehicle-utts-modal-1-area1-text utts-bold"
          style={{ textAlign: 'center', color: '#eb1000', fontSize: 20 }}
        >
          <Text t="aProblemOccurred" />
        </b>
        <div style={{ display: 'flex', marginTop: 20, flexDirection: 'column' }}>
          <span className="vehicle-utts-modal-1-area1-text" style={{ textAlign: 'center' }}>
            <Text t="aProblemOccurredDuringYourTransactionUttsNotification" />
          </span>
          <span
            className="vehicle-utts-modal-1-area1-text"
            style={{ marginTop: 20, textAlign: 'center' }}
          >
            <Text t="pleaseTryTheTransactionAgain" />
          </span>
        </div>
        <button className="utts-error-ok-button" onClick={processUTTSDevice}>
          <Text t="tryAgain" />
        </button>
        <button className="utts-error-cancel-button" onClick={() => null}>
          <Text t="giveUp" />
        </button>
      </div>
    ),
    okText: 'TEKRAR DENE',
  });
};

UTTSErrorModal.propTypes = {
  processUTTSDevice: PropTypes.func,
};

export default UTTSErrorModal;
